/*
 * -----------------------------------------------------------------------
 *  <copyright file="audit-log/types/risk-evaluation-model.tsx" company="Triumph Research Intelligence">
 *      Copyright (C) 2019 by Triumph Research Intelligence. All rights reserved.
 *  </copyright>
 * -----------------------------------------------------------------------
 */

import React from 'react';
import { FieldChangeGrid } from 'views/pages/admin/audit-log/change-grid';
import AuditEnumValues from 'views/pages/admin/audit-log/definitions/enums';
import { getFieldChangeItems, getProcessedFieldChangeItems } from 'views/pages/admin/audit-log/service';

const RiskEvaluationModelRecordChangeGrid = ({ oldRecord, newRecord, oldItem, newItem }: any) => {
    const refactoredOldRecord = {
        ...oldRecord,
        ReviewPeriodDays: null,
        Likelihood: oldRecord.Likelihood?.filter((item: any) => item) ?? null,
        Impact: oldRecord.Impact?.filter((item: any) => item) ?? null,
        Detectability: oldRecord.Detectability?.filter((item: any) => item) ?? null,
    };
    const refactoredNewRecord = {
        ...newRecord,
        ReviewPeriodDays: null,
        Likelihood: newRecord.Likelihood?.filter((item: any) => item) ?? null,
        Impact: newRecord.Impact?.filter((item: any) => item) ?? null,
        Detectability: newRecord.Detectability?.filter((item: any) => item) ?? null,
    };

    const arrayOfObjects = {
        Likelihood: {
            valueResolver: null as any,
        },
        Impact: {
            valueResolver: null as any,
        },
        Detectability: {
            valueResolver: null as any,
        },
        RAGMap: {
            valueResolver: (recordData: any, item: any) => {
                let value = '';
                for (const property in recordData) {
                    if (property.toLowerCase().match('colour')) {
                        const colour = AuditEnumValues.EvaluationColour[recordData[property]];
                        value += `Color: ${colour}; `;
                    } else value += `${property}: ${recordData[property] ?? '--'}; `;
                }
                return value;
            },
        },
    };

    const items = getFieldChangeItems(refactoredOldRecord, refactoredNewRecord, null, (field: string) =>
        getProcessedFieldChangeItems({
            oldRecord: refactoredOldRecord,
            newRecord: refactoredNewRecord,
            oldItem,
            newItem,
            field,
            arrayOfObjects,
        }),
    );

    return <FieldChangeGrid items={items} />;
};

export { RiskEvaluationModelRecordChangeGrid };
